import React from 'react';
import { Box, Skeleton, Grid, Container } from '@mui/material';
import { styled } from '@mui/material/styles';

const SkeletonCard = styled(Box)(({ theme }) => ({
  background: 'rgba(255, 255, 255, 0.1)',
  backdropFilter: 'blur(10px)',
  borderRadius: theme.shape.borderRadius * 2,
  padding: theme.spacing(4),
  height: '100%',
}));

const ProfileSkeleton = () => {
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 4, gap: 2 }}>
        <Skeleton variant="circular" width={50} height={50} />
        <Box>
          <Skeleton variant="text" width={150} height={32} />
          <Skeleton variant="text" width={120} height={24} />
        </Box>
      </Box>

      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <SkeletonCard>
              <Skeleton variant="text" width={200} height={32} sx={{ mb: 3 }} />
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Skeleton variant="rounded" height={56} />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Skeleton variant="rounded" height={56} />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Skeleton variant="rounded" height={56} />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Skeleton variant="rounded" height={56} />
                </Grid>
              </Grid>
              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                <Skeleton variant="rounded" width={120} height={36} />
              </Box>
            </SkeletonCard>
          </Grid>

          <Grid item xs={12}>
            <SkeletonCard>
              <Skeleton variant="text" width={200} height={32} sx={{ mb: 3 }} />
              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <Skeleton variant="rounded" height={56} />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Skeleton variant="rounded" height={56} />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Skeleton variant="rounded" height={56} />
                </Grid>
              </Grid>
              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                <Skeleton variant="rounded" width={150} height={36} />
              </Box>
            </SkeletonCard>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ProfileSkeleton;